export const onExitConfirm = () => {
  sessionStorage.setItem("exitConfirm", "true");
};

export const offExitConfirm = () => {
  sessionStorage.setItem("exitConfirm", "");
};
